import { useState } from "react";
import { Menu, X } from "lucide-react";
import logo from "../images/Mascot-logo.png";

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-primary shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img src={logo} alt="Bookshelf" className="h-10 w-10" />
          <a href="/" className="text-2xl font-bold text-gray-900">Bookshelf</a>
        </div>

        {/* Desktop links */}
        <div className="hidden md:flex gap-8 items-center">
          <a href="#features" className="text-gray-600 hover:text-accent transition">Features</a>
          <a href="#vision" className="text-gray-600 hover:text-accent transition">Vision</a>
          <a href="#beta-list" className="bg-accent hover:bg-primary-light text-white font-semibold px-6 py-2 rounded-lg transition cursor-pointer">
            Join Beta
          </a>
        </div>

        {/* Hamburger button */}
        <button
          className="md:hidden text-gray-600 hover:text-gray-900 transition"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-primary border-t border-accent-light px-6 py-4 flex flex-col gap-4">
          <a
            href="#features"
            onClick={() => setIsOpen(false)}
            className="text-gray-600 hover:text-accent transition font-medium"
          >
            Features
          </a>
          <a
            href="#vision"
            onClick={() => setIsOpen(false)}
            className="text-gray-600 hover:text-accent transition font-medium"
          >
            Vision
          </a>
          <a
            href="#beta-list"
            onClick={() => setIsOpen(false)}
            className="bg-accent hover:bg-primary-light text-white font-semibold px-6 py-2 rounded-lg transition text-center"
          >
            Join Beta
          </a>
        </div>
      )}
    </nav>
  );
}